import * as React from 'react';
import TableHeader from './Tableheader';
import SubTable from './SubTable';
import TableMenu from './TableMenu';

const ThemeColorEnums = {
  1: '#4D8DF7',
  2: '#FF9A00',
  3: '#FF4F25',
};

import './style.less';

const clsPrefix = 'new-plan-table';
const NewPlanTable = ({ tableData, headerData, themeColors = ThemeColorEnums, style = {}, needScrollMenu = true }) => {
  const tableList =
    tableData.length > 0 &&
    tableData.reduce((resultMap, table) => {
      const item = {
        id: table.id,
        name: table.title,
      };
      return resultMap.concat(item);
    }, []);

  return (
    <div className={clsPrefix} id="new-plan-table" style={style}>
      <TableHeader rowThText={headerData.rowThText} rowThWidth={headerData.rowThWidth || 0.25} colWidth={headerData.colWidth || 0.25} headerData={headerData.headerData} marginLeft={headerData.marginLeft || '1px'} />
      {needScrollMenu && tableList.length > 1 && <TableMenu dataSource={tableList} />}
      <section className={`${clsPrefix}__tables`}>
        {tableData.map(table => (
          <SubTable dataSource={table} themeColors={themeColors} />
        ))}
      </section>
    </div>
  );
};

export default NewPlanTable;
